<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                <h1 class="page-title">Corporate Leads</h1>
            </div>
            <div class="col-sm-6 pull-right">
                <div class="col-sm-6 pull-right">
                    <!-- Import Corporate FB leads -->
                    <span *ngIf="myrole=='1' || (myrole=='6' && userId=='58') || myrole=='14'">
                        <div class="col-sm-12 text-right">
                            <p><a href="{{s3url}}crm/sample-corporate-fb-import.csv" target="_blank">Sample CSV for fb</a></p>
                            <p><a class="btn btn-success text-white" (click)="showModalFb()"><i class="fa fa-file-excel"></i> Import Corporate Fb Leads</a></p>
                           </div>
                    </span>
                    <br>
                </div>
            </div>
        </div>
    </div>
    
    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-2 mt-2">
                    <div class="col-sm-3 mt-2">
                        <input class="form-control" [(ngModel)]="search" type="text" (keyup)="loadCorporateLeads(0,perpage)" placeholder="Search" />
                    </div>
                    <div class="col-sm-3 mt-2">
                        <mat-select  placeholder="Select Status" (selectionChange)="loadCorporateLeads(0,perpage)" [(ngModel)]="status">
                            <mat-option [value]="">Select Status</mat-option>
                            <mat-option [value]="status.id" *ngFor="let status of corporate_lead_status">{{status.status_name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Circle" (selectionChange)="loadCorporateLeads(0,perpage)" [(ngModel)]="circle" multiple>
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-2 mt-2">
                        <mat-select  placeholder="Bds" (selectionChange)="loadCorporateLeads(0,perpage)" [(ngModel)]="bd" multiple >
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds_list">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-4 mt-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Enter a date range</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date" (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
    
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading" (click)="loadCorporateLeads(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i> Refresh List</button>

                    <a *ngIf="myrole!='6' && myrole!='18'" routerLink="/add-corporate-lead" class="ml-2 btn btn-success">
                        <i class="fa fa-plus" aria-hidden="true"></i> Add Corporate Lead
                    </a>
                </div>
                <div class="col-sm-6"><mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex"></mat-paginator></div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Glamyo Patient Id</th>
                        <th>Company Name</th>
                        <th>Client Name</th>
                        <th>Designation</th>
                        <th *ngIf="myrole!='6' && myrole!='18'">Company Contact Number</th>
                        <th>Company Email</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Number of Employee</th>
                        <th>Source</th>
                        <th>Form Lead Source</th>
                        <th>Created On</th>
                        <th *ngIf="myrole!='6' && myrole!='18'">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let corporate_lead of corporate_leads;let index = index;">
                        <td>{{(pageIndex*perpage)+index+1}}</td>
                        <td>{{corporate_lead.glamyo_patient_id}}</td>
                        <td>{{corporate_lead.company_name}}</td>
                        <td>{{corporate_lead.client_name}}</td>
                        <td>{{corporate_lead.designation}}</td>
                        <td *ngIf="myrole!='6' && myrole!='18'">{{corporate_lead.company_contact_number}}</td>
                        <td>{{corporate_lead.company_email}}</td>
                        <td>{{corporate_lead.description}}</td>
                        <td> {{corporate_lead.status_name}}</td>
                        <td>{{corporate_lead.number_of_employee}}</td>
                        <td><span *ngIf="corporate_lead.lead_source==1">From CRM</span></td>
                        <td>{{corporate_lead.utm_source}}</td>
                        <td>{{corporate_lead.created_on}}</td>
                        <td *ngIf="myrole!='6' && myrole!='18'">
                            <div class="dropdown">
                                <button class="btn btn-secondary dropdown-toggle" type="button" id="{{corporate_lead.id}}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Action
                                </button>
                                <div class="dropdown-menu" aria-labelledby="{{corporate_lead.id}}">
                                    <a class="dropdown-item" routerLink="/update-corporate-lead/{{corporate_lead.id}}" ><i class="fa fa-eye"></i> View</a> 
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="loading">
                        <td colspan="8" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                    </tr>
                    <tr *ngIf="loaded && !corporate_leads.length">
                        <td colspan="8" ><i class="far fa-frown"></i> No records not found</td>
                    </tr>
                </tbody>
            </table>

            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage" (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div> 
       
    </div>

</div>

<!-- The Modal -->
<div class="modal fade" id="myModalfb">
    <div class="modal-dialog">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Import Corporate Fb Data </h4>
          <button type="button" class="close" (click)="hideModalFb()"></button>
        </div>
  
        <!-- Modal body -->
          <div class="modal-body">
              <div class="form-group">
                  <div class="row">
                      <label class="col-sm-12">Upload CSV</label>
                      <input [disabled]="submitted" type="file" #csvUploadFb (change)="selectFileFb($event)" class="form-control" />
                  </div>
                  <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
              </div>
          </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn" (click)="hideModalFb()">Close</button>
        </div>
      </div>
    </div>
  </div>